import React, { memo } from 'react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#1e293b] text-white py-12" data-id="element-234">
      <div className="container mx-auto px-4 md:px-6" data-id="element-235">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-236">
          <div data-id="element-237">
            <h3 className="text-xl font-bold mb-4" data-id="element-238">Corona de Alivio 360</h3>
            <p className="text-[#a0aec0]" data-id="element-239">
              Tecnología avanzada para el alivio del dolor, respaldada por la
              ciencia y miles de usuarios satisfechos.
            </p>
          </div>
          <div data-id="element-240">
            <h4 className="text-lg font-semibold mb-4" data-id="element-241">Legal</h4>
            <ul className="space-y-2" data-id="element-242">
              <li data-id="element-243">
                <a href="#" className="text-[#a0aec0] hover:text-white transition-colors" data-id="element-244">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-245">
                <a href="#" className="text-[#a0aec0] hover:text-white transition-colors" data-id="element-246">
                  Políticas de Envío
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-247">
            <h4 className="text-lg font-semibold mb-4" data-id="element-248">Contacto</h4>
            <ul className="space-y-2" data-id="element-249">
              <li className="text-[#a0aec0]" data-id="element-250">contacto@shopysv.com</li>
              <li className="text-[#a0aec0]" data-id="element-251">+50376668786</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-[#2d3748] text-center" data-id="element-252">
          <p className="text-[#a0aec0]" data-id="element-253">
            © {currentYear} Corona de Alivio 360. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
};
export default memo(Footer);